document.addEventListener('click', (event) => {
  const pill = event.target.closest('.ht-size-pill');
  if (!pill || pill.disabled) return;

  const card = pill.closest('.ht-product-card');
  if (!card) return;

  card.querySelectorAll('.ht-size-pill').forEach((other) => {
    other.classList.toggle('is-selected', other === pill);
  });

  const input = card.querySelector('.ht-product-card__variant-input');
  if (input) input.value = pill.dataset.variantId;
});

document.addEventListener('click', (event) => {
  const tab = event.target.closest('.ht-product-grid__tab');
  if (!tab) return;

  const section = tab.closest('.ht-product-grid');
  if (!section) return;

  section.querySelectorAll('.ht-product-grid__tab').forEach((other) => {
    const isActive = other === tab;
    other.classList.toggle('is-active', isActive);
    other.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  const targetId = tab.dataset.htTabTarget;
  section.querySelectorAll('.ht-product-grid__panel').forEach((panel) => {
    const isTarget = panel.id === targetId;
    panel.style.display = isTarget ? '' : 'none';
    panel.classList.toggle('is-active', isTarget);
  });
});
